import * as Q from 'q';
import * as globalConfig from 'globalConfig';

import PromiseCacheService from "Content/ts/Shared/Services/qPromiseCache";

export class ClubSelectionCacheServices {
    static CacheService = new PromiseCacheService<boolean>();

    IsHomeClubDisabled(): Q.Promise<boolean> {
        return ClubSelectionCacheServices.CacheService.get(globalConfig.Urls.Facility.IsHomeClubDisabled);
    };
}